import {gettext} from 'topmeteo/utils/i18n';

import Column from '../../../general/components/Column';

import FavouritesOnlyToggle from './FavouritesOnlyToggle';
import ResetFavourites from './ResetFavourites';

const FavoritesLabel = gettext('Favorites');
const FavouriteTexts = [
    gettext('We have made a preselection of favorites based on your interests.'),
    gettext('Changes could be made at any time by using the star symbol.'),
];

const Info = () => (
    <Column size={3} className="ctl-mtx-info">
        <h2>{FavoritesLabel} <span className="icon-favourite" /></h2>
        {FavouriteTexts.map((text, index) => <p key={index}>{text}</p>)}
        <FavouritesOnlyToggle />
        <ResetFavourites />
    </Column>
);

export default Info;
